<script>
export default {
  props: {
    label: {
      type: String,
      default: '',
    },
    options: {
      type: Array,
      default: () => [],
    },
    selected: {
      type: String,
      default: '',
    },
    // Which key of each option object should be used as the HTML option value
    // Defaults to 'value' to preserve existing behavior in settings pages.
    valueKey: {
      type: String,
      default: 'value',
    },
    action: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      value: this.selected,
    };
  },
  watch: {
    // Keep local value in sync when parent changes `selected`
    selected(newVal) {
      this.value = newVal;
    },
  },
  methods: {
    // Safely resolve the value to use for an <option>
    // Priority: explicit valueKey -> option.key -> option.value
    getValue(option) {
      if (
        option &&
        Object.prototype.hasOwnProperty.call(option, this.valueKey)
      ) {
        return option[this.valueKey];
      }
      if (option && Object.prototype.hasOwnProperty.call(option, 'key')) {
        return option.key;
      }
      return option ? option.value : '';
    },
  },
};
</script>

<template>
  <div>
    <label for="dropdown-select">
      {{ label }}
    </label>
    <select
      id="dropdown-select"
      v-model="value"
      name="dropdown-select"
      @change="e => action(e.target.value)"
    >
      <option
        v-for="option in options"
        :key="option.key || getValue(option)"
        :value="getValue(option)"
      >
        {{ option.value }}
      </option>
    </select>
  </div>
</template>
